import React from 'react'
import { CategoriaFaqNode } from '@gql/graphql'
import { PaginaType } from 'utils/types'
import { WContainer } from 'components/atoms'
import { FaqListing, Page, RoundHead } from 'components/organisms'
import styles from './FaqTemplate.module.sass'

interface Props {
  pagina: PaginaType
  categorieFaq: CategoriaFaqNode[]
}

const FaqTemplate = (props: Props) => {
  const { pagina, categorieFaq } = props

  return (
    <Page pagina={pagina} item={{}}>
      <div className={styles.faqTemplate}>
        <RoundHead
          breadcrumbs={pagina.breadcrumbs}
          title={pagina.titolo}
          description={pagina.descrizione}
          readMore={false}
          className={styles.roundHead}
        />
        <WContainer>
          <FaqListing categorieFaq={categorieFaq} className={styles.faqListing} />  
        </WContainer>
      </div>
    </Page>
  )
}

export default FaqTemplate
